<template>
  <wine-detail-component />
</template>

<script>
import WineDetailComponent from "@/spa/components/board/wine/details/BoardDetails";

export default {
  name: "DetailPage",
  components: {
    WineDetailComponent
  }
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/wine/WineDetailPage.vue